// extracted by mini-css-extract-plugin
module.exports = {"content__htmlContent":"l_W","section__wrapper":"l_b contentWrapper","content__wrapper":"l_w","content__label":"l_X","testBorder":"l_Y"};